/**
 * URL base del API. Obligatoria (sin fallback silencioso a host local).
 */
export function getViteApiUrl(): string {
  const u = import.meta.env.VITE_API_URL;
  if (typeof u !== 'string' || !u.trim()) {
    throw new Error(
      'VITE_API_URL no está definida. Configura la URL del API en el archivo .env del proyecto.',
    );
  }
  return u.replace(/\/$/, '');
}
